import { aboutData } from "../data/mock";
import { Check, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export const AboutSection = () => {
  return (
    <section
      id="about"
      className="relative w-full"
      style={{ background: "#0B0E1E", padding: "120px 7.6923%" }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="relative overflow-hidden rounded-xl" style={{ aspectRatio: "4/3" }}>
              <img
                src={aboutData.image}
                alt="Manchi Group Team"
                className="w-full h-full object-cover"
                style={{ filter: "brightness(0.85) contrast(1.1)" }}
              />
              {/* Overlay border */}
              <div
                className="absolute inset-0 rounded-xl"
                style={{ border: "1px solid rgba(123,104,238,0.2)" }}
              />
              {/* Purple tint overlay */}
              <div
                className="absolute inset-0 rounded-xl"
                style={{ background: "linear-gradient(135deg, rgba(123,104,238,0.1), transparent)" }}
              />
            </div>
            {/* Decorative element */}
            <div
              className="absolute -bottom-4 -right-4 w-32 h-32 rounded-lg"
              style={{ border: "1px solid rgba(123,104,238,0.15)" }}
            />
          </motion.div>

          {/* Right - Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-[2px] rounded-full" style={{ background: "#7B68EE" }} />
              <span
                className="text-sm tracking-widest uppercase"
                style={{ color: "#7B68EE", fontFamily: "'Kode Mono', monospace" }}
              >
                About Us
              </span>
            </div>

            <h2
              style={{
                fontFamily: "'Kode Mono', monospace",
                fontWeight: 600,
                fontSize: "clamp(28px, 3.5vw, 42px)",
                color: "#F0F0FF",
                letterSpacing: "-0.02em",
                lineHeight: 1.15,
                marginBottom: "24px",
              }}
            >
              {aboutData.title}
            </h2>

            <p
              style={{
                fontFamily: "'Kode Mono', monospace",
                fontSize: "15px",
                color: "#9494B8",
                lineHeight: 1.7,
                marginBottom: "40px",
              }}
            >
              {aboutData.description}
            </p>

            {/* Points */}
            <div className="flex flex-col gap-4 mb-10">
              {aboutData.points.map((point, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className="flex items-center gap-4"
                >
                  <div
                    className="w-7 h-7 flex items-center justify-center flex-shrink-0 rounded-md"
                    style={{ background: "rgba(123,104,238,0.12)", border: "1px solid rgba(123,104,238,0.2)" }}
                  >
                    <Check size={14} style={{ color: "#A78BFA" }} />
                  </div>
                  <span
                    style={{
                      fontFamily: "'Kode Mono', monospace",
                      fontSize: "15px",
                      color: "#B8B8D0",
                    }}
                  >
                    {point}
                  </span>
                </motion.div>
              ))}
            </div>

            {/* CTA */}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => {
                const el = document.querySelector("#contact");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center gap-3 cursor-pointer rounded-lg"
              style={{
                background: "rgba(123,104,238,0.12)",
                color: "#C4B5FD",
                padding: "14px 28px",
                fontSize: "16px",
                fontWeight: 500,
                fontFamily: "'Kode Mono', monospace",
                transition: "background 0.4s ease-in-out",
                border: "1px solid rgba(123,104,238,0.25)",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(123,104,238,0.2)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(123,104,238,0.12)"; }}
            >
              Work With Us
              <ArrowUpRight size={18} />
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
